$(document).ready(function () {
    // turn on the slider when there are more than 5 logos and when the extension is less than 768
    function initializeMarquee() {
        const slider_partners = $('.section-trust-block .wrap-trust-icons');
        const slides = slider_partners.children(); // child elements
        const windowWidth = $(window).width();

        if ((windowWidth < 768) || (windowWidth >= 768 && slides.length > 5)) {
            if (slider_partners.length) {
                slider_partners.liMarquee({
                    scrollStop: false,
                    circular: true,
                    startShow: true,
                    hoverStop: false,
                    dragAndDrop: false
                });
            }
        }
    }

    initializeMarquee();
});



